/*!
 * DashboardPage
 */

import Helpers from '../base/helpers.js';
import {Globals, Variables} from '../base/globals.js';

export default class DashboardPage {
  constructor() {
    if (
      !document.querySelector('[data-adjust]') &&
      !document.querySelector('[data-schematic-depth]')
    ) {
      return null;
    }

    this._addListeners();
    this._init();
  }

  _init() {
    if (document.querySelector('#dashboardCardView')) {
      this._adjustHeight();
    }

    if (document.querySelector('[data-schematic-depth="5"]')) {
      this._rollingMarquee();
    }
  }

  _addListeners() {
    if (document.querySelector('#dashboardCardView')) {
      this.throttledAdjustHeight = Helpers.Throttle(this._adjustHeight.bind(this), 200);
      window.addEventListener('resize', this.throttledAdjustHeight);
    }
  }

  _rollingMarquee() {
    let roller = document.querySelector('.marquee-roller');
    roller.id = 'roller1';

    let clone = roller.cloneNode(true);
    clone.id = 'roller2';
    document.querySelector('.marquee').appendChild(clone);

    document.querySelector('#roller1').style.left = '0px';
    document.querySelector('#roller2').style.left =
      document.querySelector('.marquee-roller ul').offsetWidth + 'px';

    roller.classList.add('original');
    clone.classList.add('clone');
  }

  _adjustHeight() {
    const container = document.querySelector('[data-adjust="container"]');
    const items = container.querySelectorAll('[data-adjust="item"]');

    if (window.matchMedia(`(min-width: ${Globals.xxl})`).matches) {
      let adjustedHeight = items[1].offsetHeight;
      for (let i = 0; i < items.length; i++) {
        items[i].style.minHeight = `${this._getMinHeight(container)}px`;
        items[0].style.height = `${adjustedHeight}px`;
      }
    } else {
      items.forEach((item) => {
        item.style.minHeight = '';
        item.style.height = '';
      });
    }
  }

  _getReferenceElementHeight(el) {
    return el.offsetHeight;
  }

  _getMinHeight(container) {
    const childrens = container.querySelectorAll('[data-adjust="child"]:not(.flex-grow-1)');
    const containerHeight = container.clientHeight;
    const inflexibleChildrensHeight = this._getInflexibleChildrensHeight(childrens);
    const remainingHeight = container.clientHeight - inflexibleChildrensHeight;
    return remainingHeight;
  }

  _getInflexibleChildrensHeight(els) {
    let totalHeight = 0;
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      totalHeight += el.clientHeight;
    }
    return totalHeight;
  }
}
